export const FEE = 0.015
export const FEE_EXCLUDED = 0.9985
